import { render, staticRenderFns } from "./LaunchScreen.vue?vue&type=template&id=275cf990&scoped=true&"
import script from "./LaunchScreen.vue?vue&type=script&lang=ts&"
export * from "./LaunchScreen.vue?vue&type=script&lang=ts&"
import style0 from "./LaunchScreen.vue?vue&type=style&index=0&id=275cf990&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275cf990",
  null
  
)

export default component.exports